import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "menu-mobile-list-dashboard" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src", "alt"]

interface Props {
    dataListSidebar: any
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MenuList',
  props: {
    dataListSidebar: null
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'close', payload: MouseEvent): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    dataListSidebar: any
};







return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.dataListSidebar, (item) => {
        return (_openBlock(), _createElementBlock("li", {
          key: item.id,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, [
          _createVNode(_component_router_link, {
            ref_for: true,
            ref: "RouterElement",
            to: { name: item.nameRoute },
            class: "item",
            "active-class": "item-active"
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                class: "active-icon",
                src: require('@/assets/image/icons/menu/active/' + item.iconActive),
                alt: ""
              }, null, 8, _hoisted_2),
              _createElementVNode("img", {
                class: "normal-icon",
                src: require('@/assets/image/icons/menu/' + item.icon),
                alt: item.nameRoute
              }, null, 8, _hoisted_3),
              _createElementVNode("span", null, _toDisplayString(item.name), 1)
            ]),
            _: 2
          }, 1032, ["to"])
        ]))
      }), 128))
    ])
  ]))
}
}

})